import axios from "../../../../api/axios"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import loadingIcon from '../../../../Images/loading.gif'
import { useAuth } from '../../../../ContextApp/AuthContext';
import './titulariatcss.css'


import { isEmpty } from "../../../../Utilities/Utils"
import Swal from "sweetalert2"

function Insertion(){
    const {user}=useAuth()
    const [enseignants,setEnseignants]=useState([])
    const [loading,setLoading]=useState(false)
    const [classes,setClasses]=useState([])
    const [classe,setClasse]=useState("")
    const [msg,setMsg]=useState("")
    const records=classes.filter((clas)=>clas.idtitulaire==null)
    const listenseignants=enseignants.filter((ensei)=>ensei.idclasse===Number(classe))
   // const recordsenseignants=enseignants.filter((ensei)=>ensei.idclasse==classe)
  // const uniqueenseignant=[...new Set(recordsenseignants.flatMap(({enseignants})=>enseignants))]
    const navigate=useNavigate()
    useEffect(()=>{
        handleclasses()
        enseignantRequest()
    },[])
    const handleclasses=async()=>{
        await axios.post('api/getclasses',{idecole:user?.ecole?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then((res)=>{
            setClasses(res.data.items)
        }).catch((err)=>{
    })
    }
    
    const HandleChangeClasse=(e)=>{
        setClasse(e.target.value)
    }
   /* const handleenseignants=async()=>{
            await axios.post('api/getenseignantclasse',{idecole:localStorage.getItem('idecole'),annee_scolaire:localStorage.getItem("annee_scolaire")}).then((res)=>{
                setEnseignants(res.data.items)
            }).catch((err)=>{

            })
    }
*/
     const enseignantRequest=async ()=>{
            await axios.post('api/getenseignantclasseecole',{idecole:user?.ecole?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then(
                (res)=>{
                  setEnseignants(res.data.items)
                 
                    
                }
            ).catch((err)=>{
                console.log(err)
            })
        }
    const handlchek=()=>{
        document.querySelector('input[name=enseignant]:checked')===null ?
            Swal.fire({
                title:"Erreur de soumission",
                text:"Aucun titulaire n'a été seléctionné",
                icon:"error"
            })
        :
            Swal.fire({
                title:"Demande de confirmartion",
                text: "Etes-vous sûr de vouloir confirmer ?",
                icon:'question',
                showConfirmButton:true,
                showCancelButton:true,
                confirmButtonText:"Confirmer"
            }).then((res)=>{
                res.isConfirmed &&
                   handlesubmit()
            })
    }
    const handlesubmit=async()=>{
        const valeur=document.querySelector('input[name=enseignant]:checked').value
        await axios.post('api/Titulariat',{idecole:user?.ecole?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire,idclasse:classe,idenseignant:valeur}).then((res)=>{
             if( res?.data?.status==200){
                Swal.fire({
                    title:"Confirmation",
                    text:res?.data?.message,
                    icon:"success"
                })
                setClasse("")
                handleclasses()

             }
              else if (res?.data?.status==410) {
                Swal.fire({
                    title:"Erreur d'enregistrement",
                    text:res?.data?.message,
                    icon:"error"
                })
              }
                    
        }).catch((err)=>{

        })
    }
const Iteration = () => {
    if (loading) {
        return (
            <div className="col-12 text-center py-5">
                <div className="spinner-border text-primary" role="status"></div>
                <p className="text-muted mt-2">Recherche des enseignants...</p>
            </div>
        );
    }

    if (listenseignants.length === 0) {
        return (
            <div className="col-12 text-center py-4">
                <div className="alert alert-warning border-0 shadow-sm">
                    <i className="bi bi-exclamation-triangle me-2"></i>
                    Aucun enseignant disponible pour cette sélection.
                </div>
            </div>
        );
    }

    return listenseignants.map((enseign, indexV) => (
        <div className="col-12 col-md-6 col-lg-4 mb-3" key={enseign.idenseignant || indexV}>
            <label className="w-100 cursor-pointer">
                <input 
                    type="radio" 
                    name="enseignant" 
                    className="btn-check" // Cache le bouton radio standard
                    value={enseign.idenseignant} 
                    id={`enseign-${indexV}`}
                />
                <div className="card h-100 border-2 shadow-sm teacher-card transition-all">
                    <div className="card-body d-flex align-items-center p-3">
                        <div className="rounded-circle bg-primary bg-opacity-10 p-3 me-3">
                            <i className="bi bi-person-fill text-primary fs-4"></i>
                        </div>
                        <div className="flex-grow-1 text-truncate">
                            <h6 className="mb-0 fw-bold text-capitalize">{enseign.nom_complet}</h6>
                            <small className="text-muted small">Cliquer pour choisir</small>
                        </div>
                        <div className="check-icon opacity-0">
                            <i className="bi bi-check-circle-fill text-success fs-4"></i>
                        </div>
                    </div>
                </div>
            </label>
        </div>
    ));
};

    return(
        <>
            <div className="container py-4">
    {/* Section Sélection Classe */}
    <div className="row justify-content-center mb-5">
        <div className="col-12 col-lg-8">
            <div className="card border-0 shadow-sm rounded-4 bg-primary text-white p-4">
                <div className="row align-items-center">
                    <div className="col-md-7">
                        <h4 className="fw-bold mb-1">Configuration du Titulaire</h4>
                        <p className="mb-md-0 opacity-75">Sélectionnez d'abord la classe concernée.</p>
                    </div>
                    <div className="col-md-5">
                        <select 
                            className="form-select form-select-lg border-0 shadow-sm" 
                            onChange={HandleChangeClasse} 
                            value={classe}
                        >
                            <option value="" disabled>Choisir la classe...</option>
                            {records.map((clas) => (
                                <option key={clas.id} value={clas.id}>{clas.nom}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>

    {/* Section Liste Enseignants (si classe sélectionnée) */}
    {!isEmpty(classe) && (
        <div className="row g-3 animate__animated animate__fadeIn" id="liste_enseignant">
            <div className="col-12 d-flex align-items-center mb-3">
                <div className="vr me-3 opacity-100 text-primary" style={{width: '4px', borderRadius: '2px'}}></div>
                <h5 className="fw-bold mb-0 text-dark">Choisissez le titulaire parmi la liste</h5>
            </div>
            
            {/* Affichage de la fonction Iteration */}
            {Iteration()}

            {/* Message d'erreur s'il y en a un */}
            {msg && (
                <div className="col-12 mt-3">
                    <div className="alert alert-danger border-0 shadow-sm py-2">
                        <i className="bi bi-info-circle me-2"></i>{msg}
                    </div>
                </div>
            )}

            {/* Bouton de soumission flottant ou fixe */}
            {listenseignants.length > 0 && (
                <div className="col-12 text-center mt-5">
                    <button 
                        className="btn btn-primary btn-lg rounded-pill px-5 shadow fw-bold py-3" 
                        type="button" 
                        onClick={handlchek}
                    >
                        <i className="bi bi-check-lg me-2"></i> Confirmer l'assignation
                    </button>
                    <p className="text-muted small mt-3">Vérifiez bien le nom avant de soumettre.</p>
                </div>
            )}
        </div>
    )}
</div>
        </>
    )
}
export default Insertion